import MoveYourPay from 'features/believe/moveYourPay/MoveYourPay/MoveYourPayScreen';
import React from 'react';
import { PinwheelContextProvider } from 'shared/providers/pinwheel/PinwheelContextProvider/PinwheelContextProvider';

export default function Page() {
  return (
    <PinwheelContextProvider>
      <MoveYourPay />
    </PinwheelContextProvider>
  );
}
